import useSwitchState from '@anm/hooks/useSwitchState';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { streamActions, streamSelectors } from '../../../../store/modules/stream';
import { userSelectors } from '../../../../store/modules/user';

import { getRoomUrl } from './../helpers';

const useSuccessModal = () => {
  const dispatch = useDispatch();
  const maxGuests = useSelector(userSelectors.selectStreamMaxGuests);
  const { stream, params } = useSelector(streamSelectors.selectCreateStreamEntity);
  const [isSuccessModalOpen, openSuccessModal, closeSuccessModal] = useSwitchState();

  const isDuplicatedRecord = params?.isDuplicate && params.kind === 'RECORD';
  const canShowSuccessModal = stream && !isDuplicatedRecord;

  const handelClearCreateStreamModal = () => dispatch(streamActions.clearCreatedStream());

  const [roomUrl, setRoomUrl] = useState('');

  useEffect(() => {
    if (!stream) return;

    setRoomUrl(
      getRoomUrl({
        id: stream!.meta.roomId,
        kind: stream!.kind,
        state: stream!.state
      })
    );
  }, [stream]);

  useEffect(() => {
    canShowSuccessModal && openSuccessModal();
  }, [canShowSuccessModal]);

  const handelCloseSuccessModal = useCallback(() => {
    handelClearCreateStreamModal();
    closeSuccessModal();
  }, []);

  return [isSuccessModalOpen, roomUrl, maxGuests, handelCloseSuccessModal] as const;
};

export default useSuccessModal;
